export default "__VITE_ASSET__CuN5jASJ__"